import { createFileRoute, redirect } from "@tanstack/react-router";

// Where other zypl apps send a user signed in: `/handoff?code=…`. The code is
// taken out of the address at startup, on any path (see `beginHandoff`), so
// by now this only has to move on to the sign-in screen, which passes a
// session on to the start page. The not-found redirect would not survive a
// hard load.
export const Route = createFileRoute("/handoff")({
	beforeLoad: () => {
		throw redirect({ to: "/login", replace: true });
	},
});
